import React from 'react';
import { useDarkClasses } from '../../../hooks/useDarkClasses';
interface PublishConfirmModalProps {
  darkMode: boolean;
  isProcessing: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  publishToAfterTide?: boolean;
}
export const PublishConfirmModal: React.FC<PublishConfirmModalProps> = ({
  darkMode,
  isProcessing,
  onConfirm,
  onCancel,
  publishToAfterTide
}) => {
  const dk = useDarkClasses();
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" data-id="element-21039" data-mp="2mnlf3by5j830">
      <div className={`w-full max-w-md p-6 rounded-xl shadow-xl ${dk.card}`} data-id="element-21040" data-mp="2hpa6f4jlf3md">
        <h3 className={`text-xl font-bold mb-2 ${dk.textHeading}`} data-id="element-21041" data-mp="2wm17rjctupem">
          Ready to Publish?
        </h3>
        <p className={`mb-4 ${dk.textSecondary}`} data-id="element-21042" data-mp="2rpasuzcrdzus">
          This will make your listing visible to everyone in the marketplace.
          Are you sure you want to proceed?
        </p>

        {publishToAfterTide && <div className="mb-6 p-3 rounded-lg bg-[#1a1a2e] border border-[#e2b04a]/30" data-id="element-21043" data-mp="xbt2l4kyyow2">
            <p className="text-sm text-[#e2b04a] flex items-center" data-id="element-21044" data-mp="1qih7k9j0geqz">
              <span className="mr-2" data-id="element-21045" data-mp="1uhq2hhpseio4">✨</span>
              This book will also be published to AfterTide.
            </p>
          </div>}

        <div className="flex justify-end space-x-3" data-id="element-21046" data-mp="1zfhs252ylsp5">
          <button onClick={onCancel} disabled={isProcessing} className={`px-4 py-2 rounded-lg font-medium ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'}`} data-id="element-21047" data-mp="248klmd7ql25c">
            Cancel
          </button>
          <button onClick={onConfirm} disabled={isProcessing} className="px-4 py-2 bg-purple-600 text-white rounded-lg font-medium hover:bg-purple-700 flex items-center" data-id="element-21048" data-mp="2e8la0dkgq8ge">
            {isProcessing ? <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2" data-id="element-21049" data-mp="nvckelxsbqcl"></div>
                Publishing...
              </> : 'Confirm Publish'}
          </button>
        </div>
      </div>
    </div>;
};